// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1oK77","content":"styles_content__2tWt4","closeBtn":"styles_closeBtn__2yPfv","overlay":"styles_overlay__YRyOQ"};